export const LOADING = 'LOADING';
export const SET_ERROR = 'SET_ERROR';
export const SET_REDIRECT = 'SET_REDIRECT';
export const GET_LEAD = 'GET_LEAD';
export const CLEAR_LEAD = 'CLEAR_LEAD';
export const SET_REDIRECT_TO_ALL_LEADS = 'REDIRECT_TO_ALL_LEADS';
export const DOWNLOADING = 'DOWNLOADING';
